import { SxProps, Theme } from '@mui/material';

const compactButtonStyles = {
  fontSize: '0.75rem',
  lineHeight: 1.25,
  minHeight: 24,
  padding: '2px 8px',
};

export const toolbarContainerStyles = {
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  padding: '8px 0',
  backgroundColor: 'background.paper',
  borderBottom: '1px solid',
  borderColor: 'divider',
  '& .MuiButton-root': compactButtonStyles,
  '& .MuiButtonGroup-grouped': {
    minWidth: 28,
  },
  '& .MuiSvgIcon-root': {
    fontSize: '1rem',
  },
};

export const navigationContainerStyles: SxProps<Theme> = {
  display: 'flex',
  alignItems: 'center',
  gap: 0.5,
};

export const actionsContainerStyles: SxProps<Theme> = {
  display: 'flex',
  alignItems: 'center',
  gap: 0.5,
};

export const labelStyles: SxProps<Theme> = {
  fontWeight: 500,
  fontSize: '0.875rem',
  ml: 1,
};

export const dateButtonStyles: SxProps<Theme> = {
  fontWeight: 500,
  fontSize: '0.875rem',
  ml: 1,
  textTransform: 'none',
  color: 'text.primary',
  minHeight: 24,
  padding: '2px 8px',
};

export const buttonStyles: SxProps<Theme> = {
  textTransform: 'none',
  ...compactButtonStyles,
};

export const viewButtonStyles: SxProps<Theme> = {
  textTransform: 'capitalize',
  ...compactButtonStyles,
};

/** Workboard calendar view toggle (month / week) — dark mode only */
export const getViewButtonDarkSx = (selected: boolean): SxProps<Theme> => ({
  textTransform: 'capitalize',
  ...compactButtonStyles,
  ...(selected
    ? {
      bgcolor: '#2a2a2f',
      border: '1px solid #ebebee',
      color: 'text.primary',
      '&:hover': {
        bgcolor: '#2a2a2f',
        border: '1px solid #ebebee',
      },
    }
    : {
      bgcolor: '#111111',
      border: '1px solid #646464',
      color: 'text.primary',
      '&:hover': {
        bgcolor: '#111111',
        border: '1px solid #646464',
      },
    }),
});
